import { Component, Input, OnInit } from '@angular/core';
import { LoyaltyService } from 'src/app/services/loyalty.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-loyalty-analytics',
  templateUrl: './loyalty-analytics.component.html',
  styleUrls: ['./loyalty-analytics.component.scss']
})
export class LoyaltyAnalyticsComponent implements OnInit {

  @Input() storeId: string = '';

  loading: boolean = false;
  analyticsData: any = null;

  fromDate: string = '';
  toDate: string = '';

  constructor(
    private loyaltyService: LoyaltyService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    this.fromDate = this.toInputDate(firstDay);
    this.toDate = this.toInputDate(now);

    if (this.storeId) {
      this.loadAnalytics();
    }
  }

  private toInputDate(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  loadAnalytics(): void {
    this.loading = true;
    this.analyticsData = null;
    const from = this.fromDate ? new Date(this.fromDate + 'T00:00:00').toISOString() : undefined;
    const to = this.toDate ? new Date(this.toDate + 'T23:59:59').toISOString() : undefined;

    this.loyaltyService.getAnalytics(this.storeId, from, to).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.analyticsData = res.data || res.response?.data || null;
      },
      error: (err: any) => {
        this.loading = false;
        if (err.status !== 404) {
          this.toastr.error(err.error?.response?.message || 'Failed to load loyalty analytics');
        }
        this.analyticsData = null;
      }
    });
  }

  formatCurrency(value: number): string {
    if (!value && value !== 0) return '—';
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(value);
  }

  get totalDiscountGiven(): number {
    return this.analyticsData?.totalDiscountGiven ?? 0;
  }

  get activeMemberCount(): number {
    return this.analyticsData?.activeMemberCount ?? 0;
  }

  get memberAvgBasket(): number {
    return this.analyticsData?.memberAvgBasket ?? 0;
  }

  get nonMemberAvgBasket(): number {
    return this.analyticsData?.nonMemberAvgBasket ?? 0;
  }

  get discountByTier(): any[] {
    return this.analyticsData?.discountByTier ?? [];
  }

  get topDiscountedCategories(): any[] {
    return this.analyticsData?.topDiscountedCategories ?? [];
  }

  get basketLift(): number {
    const member = this.memberAvgBasket;
    const nonMember = this.nonMemberAvgBasket;
    if (!nonMember) return 0;
    return Math.round(((member - nonMember) / nonMember) * 100);
  }

  trackById(index: number, item: any): string {
    return item.tierKey || item.categoryName || String(index);
  }
}
